// Why the app signed a learner out.
//
// Before this file the only thing that survived a sign-out was the fact of
// one. `authCode()` mapped a 429, a 403 and a 5xx to the same bucket as a 401,
// so "the app logs people out" had no answer and no measurement.

import type { Capture } from "../analytics/events.ts";

export type SignOutCause =
	| "explicit"
	| "account401"
	| "account429"
	| "account403"
	| "account5xx"
	| "accountNetwork"
	| "content401"
	| "sync401";

const DESCRIBE: Record<SignOutCause, string> = {
	explicit: "learner chose",
	account401: "session rejected",
	account429: "rate limited",
	account403: "account forbidden",
	account5xx: "account server error",
	accountNetwork: "network",
	content401: "content unauthorized",
	sync401: "sync unauthorized",
};

export const describeCause = (cause: SignOutCause): string => DESCRIBE[cause];

/** What a sign-out is recorded through: the apps' typed sink. */
export interface CaptureSink {
	capture: Capture;
}

/**
 * The one place a sign-out is recorded. `type` is Appwrite's raw error type
 * string — useful for spotting a cause nobody anticipated, and never shown to
 * a learner. The caller passes no sink when analytics is not configured.
 */
export function captureSignOut(
	sink: CaptureSink | undefined,
	cause: SignOutCause,
	type?: string,
): void {
	sink?.capture("signed_out", {
		cause,
		cause_detail: DESCRIBE[cause],
		...(type ? { appwrite_type: type } : {}),
	});
}
